import { useTranslation } from 'react-i18next';

import { DataPanelGroup, DataPanelInlineItem, DataPanelRow, PanelInfoWithIcon, PositionSourceBadge } from '@/ui';
import type { PortalLocationRedacted } from '@/signalr';
import { DateFormatter } from '@/features/shared/DateFormatter';
import { toUiLocationSource } from '@ngsos/portal-core/incidents';

export type RedactedLocationSummaryProps = {
  location: PortalLocationRedacted;
};

export function RedactedLocationSummary({ location }: RedactedLocationSummaryProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-light p-2">
      <PanelInfoWithIcon icon="fal fa-location-crosshairs-slash" text={t('Incident_Location_Redacted')} />
      <div className="text-center small text-black-50 mt-1">{t('Incident_Location_Redacted_Description')}</div>
      <div className="d-flex justify-content-center my-2">
        <PositionSourceBadge positionSource={toUiLocationSource(location.source)} />
      </div>
      <DataPanelGroup>
        <DataPanelRow>
          <DataPanelInlineItem title={t('Incident_InfoPanel_LocationCapturedAt')}>
            <DateFormatter date={location.capturedAtUtc} formatType="calendar" />
          </DataPanelInlineItem>
          <DataPanelInlineItem title={t('Incident_InfoPanel_LocationReceivedAt')}>
            <DateFormatter date={location.receivedAtUtc} formatType="calendar" />
          </DataPanelInlineItem>
          <DataPanelInlineItem title={t('Incident_InfoPanel_LocationRedactedAt')}>
            <DateFormatter date={location.redactedAtUtc} formatType="calendar" />
          </DataPanelInlineItem>
        </DataPanelRow>
      </DataPanelGroup>
    </div>
  );
}
